import React from "react";
import { Sparkles, ArrowDown } from "lucide-react";
import WhatsAppButton from "./WhatsAppButton";
import { buildWA } from "../data/catalog";

const LOGO_URL = "/images/logo.png";

const Hero = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[100vh] pt-32 pb-20 overflow-hidden"
    >
      {/* gradient backdrop */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B0B0B] via-[#13031f] to-[#0B0B0B]" />
        <div className="absolute inset-0 bg-grid opacity-60" />
        <div className="hero-blob bg-[#7B2DFF]/40 w-[480px] h-[480px] -top-40 -left-32 float-slow" />
        <div className="hero-blob bg-[#9B5BFF]/30 w-[420px] h-[420px] top-20 right-[-10%] float-soft" />
        <div className="hero-blob bg-[#3a0ca3]/30 w-[360px] h-[360px] bottom-[-10%] left-1/3 pulse-glow" />
        <div className="absolute inset-0 bg-noise opacity-[0.18] mix-blend-overlay" />
      </div>

      {/* Floating neon lines */}
      <svg
        className="absolute left-0 right-0 top-[18%] w-full opacity-30 -z-10"
        viewBox="0 0 1440 200"
        fill="none"
        preserveAspectRatio="none"
      >
        <path
          d="M0 100 C 240 20, 480 180, 720 100 S 1200 20, 1440 100"
          stroke="url(#g1)"
          strokeWidth="1.5"
        />
        <defs>
          <linearGradient id="g1" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor="#7B2DFF" stopOpacity="0" />
            <stop offset="0.5" stopColor="#9B5BFF" />
            <stop offset="1" stopColor="#7B2DFF" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7 fade-up">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full glass-purple text-xs sm:text-sm text-[#cdb6ff] mb-7">
            <Sparkles size={14} className="text-[#9B5BFF]" />
            <span className="tracking-[0.14em] uppercase">Layanan Digital Premium</span>
          </div>

          <h1
            data-testid="hero-title"
            className="font-display font-black leading-[0.95] text-5xl sm:text-6xl lg:text-7xl"
          >
            <span className="block text-white">Selamat datang di</span>
            <span className="block gradient-purple text-glow mt-1">DIGIFRIEND</span>
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-6 text-base sm:text-lg text-white/65 max-w-xl leading-relaxed"
          >
            Melayani Segala Kebutuhan Digital Anda — akun premium, game repack
            aman terpercaya, hingga koleksi e-book bermanfaat dengan harga
            terjangkau & pelayanan secepat kilat.
          </p>

          <div className="mt-9 flex flex-wrap items-center gap-3 sm:gap-4">
            <WhatsAppButton
              testId="hero-cta-pesan"
              href={buildWA("Pesan Produk Digital DIGIFRIEND", "")}
            >
              Pesan Sekarang
            </WhatsAppButton>
            <a
              data-testid="hero-cta-katalog"
              href="#katalog"
              className="btn-ghost"
            >
              <ArrowDown size={18} />
              Lihat Katalog
            </a>
          </div>

          <div className="mt-12 flex flex-wrap items-center gap-x-8 gap-y-4 text-xs uppercase tracking-[0.18em] text-white/40">
            <span>● Trusted Seller</span>
            <span>● Fast Response 24/7</span>
            <span>● 100% Aman</span>
          </div>
        </div>

        {/* Logo showcase */}
        <div className="lg:col-span-5 relative flex justify-center fade-up delay-300">
          <div className="relative">
            <div className="absolute inset-0 -m-16 rounded-full bg-[#7B2DFF]/25 blur-3xl pulse-glow" />
            <div className="relative w-[280px] h-[280px] sm:w-[360px] sm:h-[360px] lg:w-[420px] lg:h-[420px] rounded-[28px] overflow-hidden glass glow-purple float-soft">
              <img
                src={LOGO_URL}
                alt="DIGIFRIEND brand mark"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Floating mini badges */}
            <div className="absolute -top-4 -left-6 px-3 py-1.5 rounded-full glass text-[11px] font-medium text-white/80 float-slow">
              ✦ Premium
            </div>
            <div className="absolute bottom-4 -right-6 px-3 py-1.5 rounded-full glass-purple text-[11px] font-semibold text-[#cdb6ff] float-soft">
              Capcut · Game · E-Book
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
